export default __webpack_public_path__ + "static/finance-page-hero-img-e6e4e6468ac197bd4ba656edb8d19518.svg";